"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActivityLog = exports.INACTIVITY_MS = void 0;
exports.INACTIVITY_MS = 5 * 60_000;
class ActivityLog {
    events = [];
    name = '';
    activity = 'balloons';
    current = null;
    constructor(events = [], name = '') { this.events = events; this.name = name; }
    add(event) { this.events.push(event); }
    tick(now) {
        if (!this.current || now - this.current.last < exports.INACTIVITY_MS)
            return false;
        this.end(this.current.last, 'inactive');
        return true;
    }
    input(now) {
        this.tick(now);
        if (!this.current) {
            this.current = { start: now, last: now, name: this.name, activity: this.activity };
            this.add({ at: now, name: this.name, activity: this.activity, kind: 'start' });
        }
        this.current.last = now;
    }
    end(now, reason) {
        if (!this.current)
            return;
        const current = this.current;
        const end = now - current.last >= exports.INACTIVITY_MS ? current.last : now;
        this.add({ at: end, name: current.name, activity: current.activity, kind: 'end', duration: Math.max(0, end - current.start), reason });
        this.current = null;
    }
    view(activity, now) {
        if (activity === this.activity)
            return;
        this.end(now, 'switched activity');
        this.activity = activity;
    }
    rename(name, now) {
        const next = name.trim().slice(0, 100);
        if (next === this.name)
            return;
        this.end(now, 'changed name');
        this.name = next;
    }
    puzzle(kind, detail, solved, now, id) {
        let event = id ? this.events.find(e => e.kind === 'activity' && e.id === id) : undefined;
        if (!event) {
            event = { at: now, name: '', activity: 'puzzle', kind: 'activity', detail, id, solved: false };
            this.add(event);
        }
        event.detail = detail;
        if (kind === 'solve' || solved)
            event.solved = true;
    }
    totals(now, name) {
        this.tick(now);
        const totals = { balloons: 0, sketchpad: 0, matching: 0, puzzle: 0 };
        for (const event of this.events)
            if (event.kind === 'end' && (name === undefined || event.name === name))
                totals[event.activity] += event.duration ?? 0;
        if (this.current && (name === undefined || this.current.name === name))
            totals[this.current.activity] += Math.max(0, now - this.current.start);
        return totals;
    }
}
exports.ActivityLog = ActivityLog;
//# sourceMappingURL=activityLog.js.map